/** zh-CN catalogue `pgr` (W3-09; English: src/formats/pgr/pgr.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const LIST =
  '{list, select, judgeLineDisappearEvents {不透明度（judgeLineDisappearEvents）} judgeLineRotateEvents {旋转（judgeLineRotateEvents）} judgeLineMoveEvents {位置（judgeLineMoveEvents）} speedEvents {流速（speedEvents）} other {{list}}}';

const catalog: MessageCatalog = {
  ns: 'pgr',
  locale: 'zh-CN',
  messages: {
    'report.notObject': '该文件不是 Phigros 谱面：其内容不是 JSON 对象。已创建一张空谱面。',
    'report.missingField': '缺少必需字段“{field}”。已使用默认值；Phira 会拒绝缺少字段的谱面。',
    'report.wrongType': '字段“{field}”的值类型错误，已忽略；Phira 会拒绝这样的谱面。',
    'report.unknownNoteType':
      '一个音符的类型为 {type}，不是 1（Tap）、2（Drag）、3（Hold）或 4（Flick）之一。已略去；Phira 会拒绝这样的谱面。',
    'report.formatVersion': 'Phira 不支持 formatVersion {version}（只支持 1 和 3）。已按 formatVersion 3 读取谱面。',
    'report.invalidBpm': '一条判定线的 BPM 为 {bpm}，不是正数。已对其使用谱面速度；否则 Phira 会显示错乱的时间。',
    'report.emptyList': `该判定线的${LIST}列表为空。Phira 会因此崩溃；已不设置该属性。`,
    'report.unsortedEvents': `${LIST}事件没有按时间顺序排列。已按 Phira 正向播放的方式转换；在 Phira 中向后跳转可能显示不同的内容。`,
    'report.nanLeadIn': `第一个${LIST}事件没有长度，因此 Phira 在它之前显示无效值。此处改用第一个值。`,
    'report.speedJump': '重叠的速度事件会让音符距离在 Phira 中发生跳变。这种跳变无法用流速表示，已被平滑处理。',
    'report.speedAfterMaxTime':
      '一个速度事件在最后一个音符之后超过一秒才开始。Phira 会让判定线一直运动到该事件开始，然后让音符距离跳变；导入时会保持运动到那时，并在那里停止，而不是跳变。',
    'report.negativeHold': '一个 Hold 音符的长度为负。已将其长度设为零。',
    'report.inexactTimes': '部分时间无法用拍数精确表示，已取整（最多 {maxMs} 毫秒）。',
    'report.timeOutOfRange': '部分时间过大或过早于开头，谱面无法容纳。已移到谱面能容纳的最近时间。',
    'report.multiBpm':
      '判定线使用了 {count} 种不同的 BPM。谱面速度为 {bpm} BPM，其他判定线已经过秒数换算，因此播放时间不变。',
    'report.reversedEvents': `${LIST}列表中结束早于开始的事件已被略去，因为 Phira 会忽略它们。`,
    'report.lastMotionIgnored': `Phira 会忽略最后一个${LIST}事件的运动，并保持其起始值。导入时也这样处理。`,
    'report.speedGaps': '速度事件之间有空隙或重叠。Phira 按各事件自己的长度使用它们，导入时会还原由此产生的速度。',
    'report.thickness': '判定线的粗细被设为 1.0002，因为 Phira 绘制 Phigros 判定线比 RPE 判定线更细。',
    'report.holdTailFrozen':
      '一个 Hold 在最后一个音符开始后超过一秒才结束。Phira 会在那里停止判定线的运动，因此 Hold 的结尾会画得更短；导入时保留这一行为。',
  },
};

export default catalog;
